import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  IconButton,
  Checkbox,
  FormControlLabel,
  Box
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import marksatteled from "../../../../assests/marksatteled.svg"
import CloseIcon from "@mui/icons-material/Close";
import "./ScheduleReport.css";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { useNavigate, useParams } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import * as XLSX from 'xlsx';
import debounce from 'lodash/debounce';
import { format } from 'date-fns';
import LoadingSpinner from "../../../Loading/component";
const TruncatedText = ({ text, maxLength = 20 }) => {
  const [showFullText, setShowFullText] = useState(false);

  if (!text || text.length <= maxLength) {
    return <span>{text || 'N/A'}</span>;
  }

  if (showFullText) {
    return (
      <span>
        {text}
        <button
          className="see-less-btn"
          onClick={() => setShowFullText(false)}
        >
          See Less
        </button>
      </span>
    );
  }

  return (
    <span>
      {text.substring(0, maxLength)}...
      <button
        className="see-more-btn"
        onClick={() => setShowFullText(true)}
      >
        See More
      </button>
    </span>
  );
};


const ScheduleMarkSettleDownloadReportComponent = ({
  loading,
  error,
  reportData,
  formatCurrency,
  onDownloadExcel,
  onGoBack,
  onMarkSettle,
  showMarkSettleDialog,
  setShowMarkSettleDialog,
  selectedDate,
  setSelectedDate,
  onMarkSettledConfirm,
  showSuccessDialog,
  onSuccessClose,
  selectedPayoutIds,
  setSelectedPayoutIds,
  selectAll,
  setSelectAll,
  payoutData
}) => {
  const [localSelectAll, setLocalSelectAll] = useState(false);

  // Handle select all checkbox
  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;
    setLocalSelectAll(isChecked);

    if (isChecked) {
      // Select all payout IDs
      const allPayoutIds = reportData.cohortScheduleResponseDto?.map(item => item.payoutId) || [];
      setSelectedPayoutIds(allPayoutIds);
    } else {
      // Clear selection
      setSelectedPayoutIds([]);
    }
  };

  // Handle individual checkbox selection
  const handleCheckboxChange = (payoutId) => {
    if (selectedPayoutIds.includes(payoutId)) {
      // Remove from selection
      setSelectedPayoutIds(selectedPayoutIds.filter(id => id !== payoutId));
      setLocalSelectAll(false);
    } else {
      // Add to selection
      setSelectedPayoutIds([...selectedPayoutIds, payoutId]);

      // If all items are selected, update the select all checkbox
      const allPayoutIds = reportData.cohortScheduleResponseDto?.map(item => item.payoutId) || [];
      if (selectedPayoutIds.length + 1 === allPayoutIds.length) {
        setLocalSelectAll(true);
      }
    }
  };

  // Update local select all when selectedPayoutIds changes
  useEffect(() => {
    const allPayoutIds = reportData.cohortScheduleResponseDto?.map(item => item.payoutId) || [];
    setLocalSelectAll(selectedPayoutIds.length === allPayoutIds.length && allPayoutIds.length > 0);
  }, [selectedPayoutIds, reportData]);

  return (
    <div className="report-page-container">
      {loading ? (
        <div className="mark-loading-spinner"> <LoadingSpinner /> </div>
      ) : error ? (
        <div className="error-message">{error}</div>
      ) : (
        <>
          <Sidebar />
          <div className="report-content-wrapper">
            <div className="report-header">
              <button className="report-back-btn" onClick={onGoBack}>
                ←
              </button>
              <h1 className="report-date">
                {reportData.date
                  ? new Date(reportData.date).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })
                  : "N/A"}
              </h1>
            </div>
            <div className="report-container">
              <div className="table-container">
                <div className="report-table-wrapper">
                  <table className="report-table">
                    <thead>
                      <tr>
                        <th>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={localSelectAll}
                                onChange={handleSelectAll}
                                disabled={!reportData.cohortScheduleResponseDto || reportData.cohortScheduleResponseDto.length === 0}
                              />
                            }
                            label="Select All"
                          />
                        </th>
                        <th>Partner ID</th>
                        <th>Partner Name</th>
                        <th>Status</th>
                        <th>Deductions</th>
                        <th>Payout</th>
                        <th>Transfer Test</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportData && reportData.cohortScheduleResponseDto?.map((row) => (
                        <tr key={row.payoutId || row.payoutId}>
                          <td>
                            <Checkbox
                              checked={selectedPayoutIds.includes(row.payoutId)}
                              onChange={() => handleCheckboxChange(row.payoutId)}
                            />
                          </td>
                          <td>{row.franchiseeId || 'N/A'}</td>

                          <td>

                            {row.payee}
                          </td>
                          <td>
                            <span className={`generatedstatus-${(row.status || 'generated').toLowerCase()}`}>
                              {row.status || 'Generated'}
                            </span>
                          </td>
                          <td>
                            <TruncatedText text={row.deductions} maxLength={20} />

                          </td>
                          <td>{formatCurrency(row.payout || 0)}</td>
                          <td>
                            <TruncatedText text={row.transferText} maxLength={20} />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Footer buttons */}
              <div className="report-footer">
                <Button
                  onClick={onDownloadExcel}
                  variant="outlined"
                  fullWidth
                  className="mark-download-btn"
                >
                  Download
                </Button>
                <Button
                  onClick={() => onMarkSettle(selectedPayoutIds)}
                  variant="contained"
                  color="secondary"
                  className="settle-btn"
                  fullWidth
                  disabled={selectedPayoutIds.length === 0}
                >
                  Mark Settle ({selectedPayoutIds.length})
                </Button>
              </div>
            </div>
          </div>

          {/* Mark Settle Dialog */}
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Dialog
              open={showMarkSettleDialog}
              maxWidth="sm"
              fullWidth={true}
              sx={{
                "& .MuiDialog-paper": {
                  width: "100%",
                  maxWidth: "500px",
                  minHeight: "280px",
                  position: "relative",
                  borderRadius: "8px",
                },
              }}
            >
              <DialogTitle
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "1.25rem",
                  padding: "20px 24px 16px",
                  position: "relative",

                }}
              >
                Mark Settle
                <IconButton
                  aria-label="close"
                  onClick={() => setShowMarkSettleDialog(false)}
                  sx={{
                    position: "absolute",
                    right: 16,
                    top: 16,
                    color: "#666"
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>

              <DialogContent sx={{ padding: "24px" }}>
                <Box sx={{ marginBottom: "20px" }}>
                  <DatePicker
                    label="Select Date to Mark this Payout as Settled"
                    value={selectedDate}
                    onChange={(newValue) => setSelectedDate(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        margin="normal"
                        sx={{
                          "& .MuiInputLabel-root": {
                            fontSize: "14px"
                          },
                          "& .MuiInputBase-root": {
                            fontSize: "14px"
                          }
                        }}
                      />
                    )}
                  />
                </Box>
                <Typography variant="body2" sx={{
                  mt: 2,
                  textAlign: "center",
                  fontSize: "14px",
                  color: "#666"
                }}>
                  Selected Payouts: {selectedPayoutIds.length}
                </Typography>
              </DialogContent>

              <DialogActions sx={{
                justifyContent: "center",
                padding: "16px 24px 24px",

              }}>
                <Button
                  onClick={onMarkSettledConfirm}
                  color="success"
                  variant="contained"
                  disabled={!selectedDate || selectedPayoutIds.length === 0}
                  sx={{
                    width: "150px",
                    padding: "8px 24px",
                    fontSize: "14px",
                    fontWeight: "600"
                  }}
                >
                  DONE
                </Button>
              </DialogActions>
            </Dialog>

            {/* Success Dialog */}
            <Dialog
              open={showSuccessDialog}
              onClose={onSuccessClose}
              fullWidth
              maxWidth="xs"
              sx={{
                "& .MuiDialog-paper": {
                  borderRadius: "8px",
                  padding: "0",
                }
              }}
            >
              <DialogContent
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  padding: "32px 24px 24px",
                }}
              >
                <img
                  style={{
                    height: "70px",
                    width: "70px",
                    marginBottom: "20px"
                  }}
                  src={marksatteled}
                  alt="success"
                />
                <DialogTitle sx={{
                  textAlign: "center",
                  padding: "0",
                  marginBottom: "8px",
                  fontSize: "1.25rem",
                  fontWeight: "bold"
                }}>
                  Marked Settled
                </DialogTitle>
                <Typography sx={{
                  marginBottom: "24px",
                  fontSize: "14px",
                  color: "#666"
                }}>
                  {selectedPayoutIds.length} payout(s) have been marked as settled.
                </Typography>
                <Button
                  onClick={onSuccessClose}
                  sx={{
                    backgroundColor: "#14AE78",
                    color: "white",
                    padding: "8px 24px",
                    fontSize: "14px",
                    fontWeight: "600",
                    width: "150px",
                    "&:hover": {
                      backgroundColor: "#119966"
                    }
                  }}
                  variant="contained"
                >
                  OK
                </Button>
              </DialogContent>
            </Dialog>
          </LocalizationProvider>
        </>
      )}
    </div>
  );
};

export default ScheduleMarkSettleDownloadReportComponent;